import React from 'react';
import { Link } from 'react-router-dom';
import './BuilderPrivateNotice.css';

export default function BuilderPrivateNotice() {
  return (
    <main className="dn-private-shell">
      <div className="dn-private-backlight" aria-hidden="true" />
      <div className="dn-private-grid" aria-hidden="true" />
      <nav className="dn-private-nav" aria-label="Private Builder navigation">
        <Link className="dn-private-brand" to="/"><span className="dn-private-brandmark">DN</span><span>DIGITAL NINJA <small>AI WEBSITE & APP BUILDER</small></span></Link>
        <span className="dn-private-label">PRIVATE SYSTEM // ACCESS CONTROL</span>
      </nav>
      <section className="dn-private-card" aria-labelledby="dn-private-title">
        <div className="dn-private-logo" aria-hidden="true">
          <div className="dn-private-orbit one" />
          <div className="dn-private-orbit two" />
          <div className="dn-private-video">
            <video autoPlay loop muted playsInline preload="metadata" src="/dn-assets/dn-logo-motion.mp4" />
          </div>
          <div className="dn-private-node a" />
          <div className="dn-private-node b" />
          <div className="dn-private-node c" />
        </div>
        <p className="dn-private-overline"><span className="dn-private-pulse" /> DIGITAL NINJA · PROPRIETARY BUILDER</p>
        <h1 id="dn-private-title">The Builder is <span>private.</span></h1>
        <p className="dn-private-message">
          Digital Ninja's application-building environment is currently reserved for its authorised internal team.
          Public accounts and public Builder access are not available.
        </p>
        <div className="dn-private-actions">
          <Link className="dn-private-button secondary" to="/">← Return to main page</Link>
          <Link className="dn-private-button primary" to="/login?next=/team/builder">DN Team Login ↗</Link>
        </div>
        <p className="dn-private-note">Team members must use their own authorised login. No shared passwords or guest access.</p>
      </section>
      <footer className="dn-private-footer">BUILT BY DIGITAL NINJA · CAPE TOWN · © 2026</footer>
    </main>
  );
}
